module.exports = __webpack_public_path__ + "static/media/auth-background.61a6e1a5.jpg";